export default function DevicesActivationsController() {

  'ngInject';

}